import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Promotion } from "@/constants/objects";

interface SelectSubscriptionPromotionProps {
  promotions: Promotion[];
  setSelectedPromotion: (promotion: Promotion | null) => void;
  selectedPromotion: Promotion | null;
}

export function SelectSubscriptionPromotion({
  promotions,
  setSelectedPromotion,
  selectedPromotion,
}: SelectSubscriptionPromotionProps) {
  return (
    <Select
      required
      value={selectedPromotion?.id || ""}
      onValueChange={(value: string) => {
        const selected = promotions.find((promotion) => promotion.id === value) || null;
        setSelectedPromotion(selected);
      }}
    >
      <SelectTrigger className="w-[180px]">
        <SelectValue placeholder="Promotion" />
      </SelectTrigger>
      <SelectContent>
        {promotions.map((promotion) => (
          <SelectItem key={promotion.id} value={promotion.id}>
            {promotion.name}
            {promotion.type === "voucher" && (
              <span className="text-muted-foreground ml-2">
                ({promotion.amountRemaining} remaining)
              </span>
            )}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
